import React, { useEffect } from 'react';

import { BrowserRouter as Router } from 'react-router-dom';

import Nav from './Nav';
import Managed, { useManaged } from './Managed';
import auth from '../lib/auth';

function App({ menu, children }) {
  const [whoAmI, setWhoAmI, setError] = useManaged();

  useEffect(() => {
    auth.whoAmI().then(setWhoAmI).catch(setError);
  }, [setWhoAmI, setError]);

  return (
    <Managed state={whoAmI}>
      <Router>
        <Nav whoAmI={whoAmI.data} menu={menu || []} />
        <div id='body'>{children}</div>
      </Router>
    </Managed>
  );
}

export default App;
